import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import {
  SzBrandBlockComponent,
  SzIconComponent,
  SzPasswordInputComponent,
  SzPasswordStrengthMeterComponent,
  SzTextInputComponent
} from '@ui';
import { AuthRoutingModule } from './auth-routing.module';
import { AppleSignInButtonComponent } from './components/apple-sign-in-button/apple-sign-in-button.component';
import { AuthDividerComponent } from './components/auth-divider/auth-divider.component';
import { GoogleSignInButtonComponent } from './components/google-sign-in-button/google-sign-in-button.component';
import { SpectrumAccentComponent } from './components/spectrum-accent/spectrum-accent.component';
import { LoginPage } from './pages/login/login.page';
import { RegisterPage } from './pages/register/register.page';
import { ResetPasswordPage } from './pages/reset-password/reset-password.page';
import { ResetPasswordSentPage } from './pages/reset-password-sent/reset-password-sent.page';
import { WelcomePage } from './pages/welcome/welcome.page';

@NgModule({
  declarations: [
    WelcomePage,
    LoginPage,
    RegisterPage,
    ResetPasswordPage,
    ResetPasswordSentPage,
    GoogleSignInButtonComponent,
    AppleSignInButtonComponent,
    SpectrumAccentComponent,
    AuthDividerComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    ReactiveFormsModule,
    RouterModule,
    TranslateModule,
    AuthRoutingModule,
    SzBrandBlockComponent,
    SzIconComponent,
    SzPasswordInputComponent,
    SzPasswordStrengthMeterComponent,
    SzTextInputComponent
  ]
})
export class AuthModule {}
